import type { AxiosResponse } from 'axios'

/**
 * Detects the backend's standardised APIResponse envelope
 * (`{ status, message, result }`) and lifts `result` to `response.data`
 * so every consumer reads flat payload without knowing about the wrapper.
 */
export function unwrapApiEnvelope(response: AxiosResponse): AxiosResponse {
  const d = response.data
  if (d && typeof d === 'object' && 'result' in d && 'status' in d && 'message' in d) {
    response.data = d.result
  }
  return response
}

/**
 * Standalone unwrap for code that doesn't go through an axios interceptor
 * (e.g. raw `axios.get` calls).
 */
export function unwrapEnvelopeData<T = unknown>(data: unknown): T {
  if (data && typeof data === 'object' && 'result' in data && 'status' in data) {
    return (data as Record<string, unknown>).result as T
  }
  return data as T
}
